import { render } from "./StatusBadge.vue?vue&type=template&id=22077518"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QIcon,QTooltip});
